import React from 'react';
import './archdemo.css';
import Pipeline from './pipeline/pipeline';
import RegisterRenaming from './registerrenaming/registerrenaming';
import Cachemem from './cachemem/cachemem';
import DRAM from './dram/dram';
import HDD from './hdd/hdd';
import SSD from './ssd/ssd';
import BranchPrediction from './branchpred/branchpred';
import { Button } from '@blueprintjs/core';
import ThemeContext from './themecontext';

export default class ArchDemo extends React.Component {

    constructor(props) {
        super(props);
        this.menuItems = {
            "Merevlemezek": <HDD/>,
            "SSD tárolók": <SSD/>,
            "Memória technológiák": <DRAM/>,
            "Cache memória": <Cachemem/>,
            "Virtuális tárkezelés": <>Fejlesztés alatt</>,
            "Utasítás pipeline": <Pipeline/>,
            "Regiszterátnevezés": <RegisterRenaming/>,
            "VLIW ütemezés": <>Fejlesztés alatt</>,
            "Elágazásbecslés": <BranchPrediction/>,
        };
        this.state = { selectedApp: "Merevlemezek", theme: "dark" };

        this.themes = {
            dark: {
                "--main-bg-color": "var(--dark-gray-4)",
                "--main-fg-color": "var(--light-gray-5)",
                "--bg-shade-1": "var(--dark-gray-2)",
                "--bg-shade-2": "var(--dark-gray-5)",
                "--main-frame-bg-color": "var(--dark-gray-3)",
                "--main-emph-light-color": "#efdaa3",
                "--main-emph-strong-color": "#D99E0B",
                "--main-error-bg": "#9E2B0E",
                "--main-border-color": "var(--gray-1)",
            },
            light: {
                "--main-bg-color": "var(--light-gray-5)",
                "--main-fg-color": "var(--dark-gray-1)",
                "--bg-shade-1": "var(--light-gray-3)",
                "--bg-shade-2": "var(--light-gray-1)",
                "--main-frame-bg-color": "white",
                "--main-emph-light-color": "#D99E0B",
                "--main-emph-strong-color": "#A67908",
                "--main-error-bg": "#FF6E4A",
                "--main-border-color": "var(--gray-5)",
            }
        }
    }

    updateTheme() {
        const theme = this.themes[this.state.theme];
        Object.entries(theme).forEach(([key, val]) => document.documentElement.style.setProperty(key, val));
        if (this.state.theme === "dark")
            document.body.classList.add("bp3-dark");
        else
            document.body.classList.remove("bp3-dark");
        const event = new CustomEvent("themeChange", { detail: { theme: this.state.theme }});
        document.dispatchEvent(event);
    }

    render() {
        return <ThemeContext.Provider value={this.state.theme}>
            <div className="demo-main-panel">
            <div className="demo-menu-container">
                <div className="demo-menu-item-placeholder"></div>
                {Object.keys(this.menuItems).map((m, ix) => 
                    <div key={ix} className={this.state.selectedApp===m ? "demo-menu-item-selected" : "demo-menu-item"} onClick={() => this.setState({selectedApp: m})}>
                        <div className="demo-menu-item-mark"/>
                        <div className="demo-menu-item-text">{m}</div>
                    </div>)}
            </div>
            <div className="demo-app-panel">
                {this.menuItems[this.state.selectedApp]}
            </div>
            <div className="demo-bottom-panel">
                <Button icon={this.state.theme === "dark" ? "flash" : "moon"} minimal="true" className="demo-theme-selector" 
                    onClick={ () => {
                        if (this.state.theme === "dark")
                            this.setState({theme: "light"}, () => this.updateTheme());
                        else 
                            this.setState({theme: "dark"}, () => this.updateTheme());
                }}/>
                <div className="copyright">© Horváth Gábor, 2020 <br/> ghorvath@hit.bme.hu</div>
            </div>
        </div>
        </ThemeContext.Provider>
    }
}
